module.exports = __webpack_public_path__ + "static/official-logo-2ab7eaa786ecac1a3b55311b0002dc7e.svg";